import { Box } from "@mui/material"
import React from "react"
import { Client, CreateClientRequest } from "../../api/Clients"
import { SessionData } from "../../api/SessionData"
import { AuthHolder } from "../../utils/Auth"
import { State } from "../../utils/UseChange"
import { LoadingBackdrop, LoadingController } from "../LoadingBackdrop/LoadingBackdrop"
import { NavigatorController } from "../Navigator/Navigator"
import ClientEditor from "./ClientEditor"

type Props = {
  authHolder: AuthHolder
  navigator: NavigatorController
  setClientID?: (id: string) => void
  sessionData: State<SessionData>
}
export default function CreateClient({ authHolder, navigator, sessionData, setClientID = () => { } }: Props) {
  const loading = React.useRef(new LoadingController())

  const save = (client: Client) => {
    loading.current.show()
    CreateClientRequest(authHolder, client).then((client) => {
      loading.current.success().then(() => {
        var newData = sessionData.value
        newData.clients.push(client)
        sessionData.set(newData)
        setClientID(client.clientID)
        navigator.pop()
      })
    }).catch(err => {
      console.error(err);
      loading.current.fail();
    })
  }
  return <Box>
    <LoadingBackdrop controller={loading.current} />
    <ClientEditor sessionData={sessionData} saveClient={save} />
  </Box>
}